function ManageOverview() {
  return (
    <div className="block">
      <p className="muted">Pick a section above to manage its content.</p>
    </div>
  )
}

export default ManageOverview
